import { PropsWithChildren, useEffect, useState } from 'react';
import { DialogContentContainer } from '../styled';
import PcrSelectorDialogForm from './PcrSelectorDialogForm';
import { PCRModel } from 'services/EpdClient';
import { ProcessStatus } from 'constants/constants';
import { Option } from 'types/types';
import { PrimaryButton, SecondaryButton } from 'components/v2/buttons';
import { HelpBox } from 'components/v2/help-boxes';
import { useScrollShadow } from 'hooks/useScrollShadow';
import styled from 'styled-components';
import { ScrollShadowDialog } from 'styles/Styles.styled';

type TProps = PropsWithChildren<{
  visible: boolean;
  onHide(): void;
  initialPcr: PCRModel | null;
  onPcrChange(pcr: PCRModel): void;
  productCategoryList: Option[];
  productCategory: Option | undefined;
  pcrList: PCRModel[];
  status: ProcessStatus;
  onProductCategorySelect: (value: Option | undefined) => void;
  disclaimerText?: string | null;
  disableCategorySelector: boolean;
}>;

const PcrSelectorDialog = ({
  visible,
  onHide,
  initialPcr,
  onPcrChange,
  productCategoryList,
  productCategory,
  pcrList,
  status,
  onProductCategorySelect,
  disclaimerText,
  disableCategorySelector,
}: TProps) => {
  const [selectedPcr, setSelectedPcr] = useState<PCRModel | null>(initialPcr);

  useEffect(() => {
    if (visible) setSelectedPcr(initialPcr);
  }, [visible, initialPcr]);

  const { isScrolled, contentRef } = useScrollShadow();

  return (
    <StyledDialog
      visible={visible}
      $isScrolled={isScrolled}
      onHide={onHide}
      header="Add Product Category Rule (PCR)"
      contentStyle={pcrList?.length > 0 ? {} : { overflowY: 'initial' }}
      resizable={false}
      style={{ width: '35rem' }}
      footer={
        <>
          <SecondaryButton label="Cancel" onClick={onHide} outlined />
          <PrimaryButton
            label="Add"
            onClick={() => {
              if (selectedPcr) onPcrChange(selectedPcr);
              onHide();
            }}
            autoFocus
            disabled={!selectedPcr}
          />
        </>
      }
    >
      <DialogContentContainer ref={contentRef}>
        {disclaimerText && <HelpBox style={{ marginBottom: '22px' }}>{disclaimerText}</HelpBox>}

        <PcrSelectorDialogForm
          selectedPcr={selectedPcr}
          onSelectedPcrChange={setSelectedPcr}
          productCategoryList={productCategoryList}
          productCategory={productCategory}
          pcrList={pcrList}
          onProductCategorySelect={onProductCategorySelect}
          status={status}
          disableCategorySelector={disableCategorySelector}
        />
      </DialogContentContainer>
    </StyledDialog>
  );
};

const StyledDialog = styled(ScrollShadowDialog)`
  .p-dialog-header-close {
    display: none;
  }
`;

export default PcrSelectorDialog;
